<a
  appClickStopPropagation
  (click)="toggleMenu()"
  fxLayout="column"
  fxLayoutAlign="center start"
  fxLayoutAlign.gt-sm="center center"
  class="menu-item menu-item-animation"
  [routerLink]="[basePath, item.link]"
  routerLinkActive="active"
  [queryParams]="item.queryParams"
  [ngClass]="{
    'parent-menu-item': children.length > 0,
    'parent-menu-item-animation': children.length > 0
  }"
>
  <div
    class="menu-item-text menu-item-text-animation"
  >
    <span
      [ngClass]="{'parent-menu-item-text-wrapper': children.length > 0}"
    >
      {{ item.text }}
    </span>
    <div
      *ngIf="children.length > 0"
      class="child-menu child-menu-animation"
      [ngClass]="{open: isOpen}"
    >
      <a
        *ngFor="let item of children"
        class="child-menu-item child-menu-item-animation"
        [ngClass]="{'active': isItemLinkActive(item, [])}"
        appClickStopPropagation
        (click)="toggleMenu()"
        [routerLink]="[basePath, item.link]"
        [queryParams]="item.queryParams"
      >
        <div
          class="child-menu-text child-menu-text-animation"
        >
          {{ item.text }}
        </div>
      </a>
    </div>
  </div>
</a>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/menu/menu-item-base/menu-item-base.component.html